__turbopack_context__.v({
  "person-card-link": "search-results-module-scss-module__6v1WYa__person-card-link",
  "results-list": "search-results-module-scss-module__6v1WYa__results-list",
  "results-list-header": "search-results-module-scss-module__6v1WYa__results-list-header",
});
